import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import Hero from '../../components/pages/SolutionDetails/Hero/Hero';
import View from '../../components/pages/SolutionDetails/View/View';
import WhatWeDeliver from '../../components/pages/SolutionDetails/WhatWeDeliver/WhatWeDeliver';
import WhyChoose from '../../components/pages/SolutionDetails/WhyChoose/WhyChoose';
import HowWeWork from '../../components/pages/SolutionDetails/HowWeWork/HowWeWork';
import TimeIsValuable from '../../components/pages/SolutionDetails/TimeIsValuable/TimeIsValuable';
import { useSolutionDetailContent } from '../../hooks/useSolutionDetailContent';
import { getSolutionBySlug } from '../../data/solutions';

const SolutionDetails = () => {
  const { slug } = useParams();
  const solution = getSolutionBySlug(slug);
  const { content, isLoading } = useSolutionDetailContent(slug, solution);

  if (!solution) {
    return <Navigate to="/solutions" replace />;
  }

  if (isLoading || !content) {
    return null;
  }

  return (
    <div>
      <Hero {...content.hero} />
      <View {...content.view} />
      <WhatWeDeliver {...content.whatWeDeliver} />
      <WhyChoose {...content.whyChoose} />
      <HowWeWork {...content.howWeWork} />
      <TimeIsValuable {...content.timeIsValuable} />
    </div>
  );
};

export default SolutionDetails;
